import { render, staticRenderFns } from "./PaymentRequisitionCommentListItem.vue?vue&type=template&id=34241c36&"
import script from "./PaymentRequisitionCommentListItem.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequisitionCommentListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports